import * as actionTypes from '../actions/actionTypes';

import { DoctorInfo, UserEyeExam } from '@interfaces/myAppointmentInterfaces';
import { RequestStatus } from '@interfaces/mainInterfaces';

import { updateObject } from '@utils/utils';

import {
    IMySavedPrescriptionItem,
    IDoctorList
} from '@interfaces/myAppointmentInterfaces';

import {
    PersonalDetails,
} from '@interfaces/myProfileInterfaces';

class InitialStateProps {
    //EYE EXAMS
    userEyeExams: UserEyeExam[] = [];
    getUserEyeExamsRequestStatus: RequestStatus = 'IDLE';
    getDoctorInfoRequestStatus: RequestStatus = 'IDLE';
    deleteEyeExamRequestStatus: RequestStatus = 'IDLE';
    syncMyEyeExamsRequestStatus: RequestStatus = 'IDLE';

    doctor: DoctorInfo = null;

    //MY SAVED PRESCRIPTIONS
    getMySavedPrescriptionsRequestStatus: RequestStatus = 'IDLE';
    mySavedPrescriptions: IMySavedPrescriptionItem[] = null;
    pdEspot: string = null;
    howToReadEspot: string = null;
    howToReadEspotCl: string = null;
    getPDEspotRequestStatus: RequestStatus = 'IDLE';
    getHowToReadEspotRequestStatus: RequestStatus = 'IDLE';
    getHowToReadEspotClRequestStatus: RequestStatus = 'IDLE';
    addPrescriptionRequestStatus: RequestStatus = 'IDLE';
    searchContactLensesRequestStatus: RequestStatus = 'IDLE';
    justUpdateId = '';

    //CL DETAILS
    clDetailsRightRequestStatus: RequestStatus = 'IDLE';
    clDetailRight = null;
    clDetailsLeftRequestStatus: RequestStatus = 'IDLE';
    clDetailLeft = null;

    //MODAL ADD DOCTOR
    openModalAddDoctor: Boolean = false;

    //GET DOCTOR
    doctorList: IDoctorList = null;
    getDoctorRequestStatus: RequestStatus = 'IDLE';

    //IN STORE SERVICES
    accessToken: string = null;
    getAccessTokenRequestStatus: RequestStatus = 'IDLE';

    //ADD TO BAG
    addToCartRequestStatus: RequestStatus = 'IDLE';

    personalDetails: PersonalDetails = null;
}

const initialState: InitialStateProps = new InitialStateProps();

const myAppointmentReducer = (state = initialState, action): InitialStateProps => {
    switch (action.type) {
        case actionTypes.GET_USER_EYE_EXAMS_PENDING:
            return updateObject(state, {
                getUserEyeExamsRequestStatus: 'LOADING',
            });
        case actionTypes.GET_USER_EYE_EXAMS_SUCCESS:
            return updateObject(state, {
                getUserEyeExamsRequestStatus: 'SUCCESS',
                userEyeExams: action.userEyeExams,
            });
        case actionTypes.GET_USER_EYE_EXAMS_ERROR:
            return updateObject(state, {
                getUserEyeExamsRequestStatus: 'ERROR',
            });
        case actionTypes.GET_DOCTOR_INFO_PENDING:
            return updateObject(state, {
                getDoctorInfoRequestStatus: 'LOADING',
            });
        case actionTypes.GET_DOCTOR_INFO_SUCCESS:
            return updateObject(state, {
                getDoctorInfoRequestStatus: 'SUCCESS',
                doctor: action.doctor,
            });
        case actionTypes.GET_DOCTOR_INFO_ERROR:
            return updateObject(state, {
                getDoctorInfoRequestStatus: 'ERROR',
            });
        case actionTypes.DELETE_EYE_EXAM_PENDING:
            return updateObject(state, {
                deleteEyeExamRequestStatus: 'LOADING',
            });
        case actionTypes.DELETE_EYE_EXAM_SUCCESS:
            return updateObject(state, {
                deleteEyeExamRequestStatus: 'SUCCESS',
            });
        case actionTypes.DELETE_EYE_EXAM_ERROR:
            return updateObject(state, {
                deleteEyeExamRequestStatus: 'ERROR',
            });
        case actionTypes.GET_ACCESS_TOKEN_PENDING:
            return updateObject(state, {
                getAccessTokenRequestStatus: 'LOADING',
            });
        case actionTypes.GET_ACCESS_TOKEN_SUCCESS:
            return updateObject(state, {
                getAccessTokenRequestStatus: 'SUCCESS',
                accessToken: action.accessToken,
            });
        case actionTypes.GET_ACCESS_TOKEN_ERROR:
            return updateObject(state, {
                getAccessTokenRequestStatus: 'ERROR',
            });
        case actionTypes.SYNC_MY_EYE_EXAMS_PENDING:
            return updateObject(state, {
                syncMyEyeExamsRequestStatus: 'LOADING',
            });
        case actionTypes.SYNC_MY_EYE_EXAMS_SUCCESS:
            return updateObject(state, {
                syncMyEyeExamsRequestStatus: 'SUCCESS',
            });
        case actionTypes.SYNC_MY_EYE_EXAMS_ERROR:
            return updateObject(state, {
                syncMyEyeExamsRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_SAVED_PRESCRIPTIONS_PENDING:
            return updateObject(state, {
                getMySavedPrescriptionsRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_SAVED_PRESCRIPTIONS_SUCCESS:
            return updateObject(state, {
                getMySavedPrescriptionsRequestStatus: 'SUCCESS',
                mySavedPrescriptions: action.mySavedPrescriptions,
            });
        case actionTypes.GET_MY_SAVED_PRESCRIPTIONS_ERROR:
            return updateObject(state, {
                getMySavedPrescriptionsRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_PENDING:
            return updateObject(state, {
                clDetailsRightRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_SUCCESS:
            return updateObject(state, {
                clDetailsRightRequestStatus: 'SUCCESS',
                clDetailRight: action.clDetailRight,
            });
        case actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_RIGHT_ERROR:
            return updateObject(state, {
                clDetailsRightRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_PENDING:
            return updateObject(state, {
                clDetailsLeftRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_SUCCESS:
            return updateObject(state, {
                clDetailsLeftRequestStatus: 'SUCCESS',
                clDetailLeft: action.clDetailLeft,
            });
        case actionTypes.GET_MY_PRESCRIPTION_CL_DETAILS_LEFT_ERROR:
            return updateObject(state, {
                clDetailsLeftRequestStatus: 'ERROR',
            });
        case actionTypes.GET_PD_ESPOT_PENDING:
            return updateObject(state, {
                getPDEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_PD_ESPOT_SUCCESS:
            return updateObject(state, {
                getPDEspotRequestStatus: 'SUCCESS',
                pdEspot: action.pdEspot,
            });
        case actionTypes.GET_PD_ESPOT_ERROR:
            return updateObject(state, {
                getPDEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_PENDING:
            return updateObject(state, {
                getHowToReadEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_SUCCESS:
            return updateObject(state, {
                getHowToReadEspotRequestStatus: 'SUCCESS',
                howToReadEspot: action.howToReadEspot,
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_ERROR:
            return updateObject(state, {
                getHowToReadEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_CL_PENDING:
            return updateObject(state, {
                getHowToReadEspotClRequestStatus: 'LOADING',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_CL_SUCCESS:
            return updateObject(state, {
                getHowToReadEspotRequestClStatus: 'SUCCESS',
                howToReadEspotCl: action.howToReadEspotCl,
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_CL_ERROR:
            return updateObject(state, {
                getHowToReadEspotClRequestStatus: 'ERROR',
            });
        case actionTypes.GET_PD_ESPOT_PENDING:
            return updateObject(state, {
                getPDEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_PD_ESPOT_SUCCESS:
            return updateObject(state, {
                getPDEspotRequestStatus: 'SUCCESS',
                pdEspot: action.pdEspot,
            });
        case actionTypes.GET_PD_ESPOT_ERROR:
            return updateObject(state, {
                getPDEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_PENDING:
            return updateObject(state, {
                getHowToReadEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_SUCCESS:
            return updateObject(state, {
                getHowToReadEspotRequestStatus: 'SUCCESS',
                howToReadEspot: action.howToReadEspot,
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_ERROR:
            return updateObject(state, {
                getHowToReadEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_CL_PENDING:
            return updateObject(state, {
                getHowToReadEspotClRequestStatus: 'LOADING',
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_CL_SUCCESS:
            return updateObject(state, {
                getHowToReadEspotRequestClStatus: 'SUCCESS',
                howToReadEspotCl: action.howToReadEspotCl,
            });
        case actionTypes.GET_HOW_TO_READ_ESPOT_CL_ERROR:
            return updateObject(state, {
                getHowToReadEspotClRequestStatus: 'ERROR',
            });
        case actionTypes.ADD_PRESCRIPTION_PENDING:
            return updateObject(state, {
                addPrescriptionRequestStatus: 'LOADING',
            });
        case actionTypes.ADD_PRESCRIPTION_SUCCESS:
            return updateObject(state, {
                addPrescriptionRequestStatus: 'SUCCESS',
            });
        case actionTypes.ADD_PRESCRIPTION_ERROR:
            return updateObject(state, {
                addPrescriptionRequestStatus: 'ERROR',
            });
        case actionTypes.JUST_UPDATE_ID:
            return updateObject(state, {
                justUpdateId: action.justUpdateId,
            });
        case actionTypes.GET_DOCTOR_PENDING:
            return updateObject(state, {
                getDoctorRequestStatus: 'LOADING',
            });
        case actionTypes.GET_DOCTOR_SUCCESS:
            return updateObject(state, {
                getDoctorRequestStatus: 'SUCCESS',
                doctorList: action.doctorList,
            });
        case actionTypes.GET_DOCTOR_ERROR:
            return updateObject(state, {
                getDoctorRequestStatus: 'ERROR',
            });
        case actionTypes.ADD_TO_CART_PENDING:
            return updateObject(state, {
                addToCartRequestStatus: 'LOADING',
            });
        case actionTypes.ADD_TO_CART_SUCCESS:
            return updateObject(state, {
                addToCartRequestStatus: 'SUCCESS',
            });
        case actionTypes.ADD_TO_CART_ERROR:
            return updateObject(state, {
                addToCartRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_PROFILE_PERSONAL_DETAILS_PENDING:
            return updateObject(state, {
                personalDetailsRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_PROFILE_PERSONAL_DETAILS_SUCCESS:
            return updateObject(state, {
                personalDetailsRequestStatus: 'SUCCESS',
                personalDetails: action.personalDetails,
            });
        case actionTypes.GET_MY_PROFILE_PERSONAL_DETAILS_ERROR:
            return updateObject(state, {
                personalDetailsRequestStatus: 'ERROR',
            });
        default:
            return state;
    }
};

export default myAppointmentReducer;
